<template>

    <FloatingPanel>

        <div class="canvas-blocks-custom-leftTextImageRight-BlockPanel">

                <CommonInputs
                    :options="options"
                />
            
        </div>

    </FloatingPanel>

</template>

<script>

import axios from "axios";
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";
import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        Tabs,
    },

    data() {
        return {
            forms: [],
        };
    },

    created() {
        this.loadForms();
    },

    methods: {

        async loadForms() {
            // Load artists.
            this.forms = (await axios.get(this.adminUrlPrefix + '/forms')).data;
        },

    },

}

</script>

<style lang="scss" scoped>

.canvas-blocks-custom-leftTextImageRight-BlockPanel {

}

</style>
